module.exports = __webpack_public_path__ + "img/aw.cf6e4350.svg";